import { render } from "./ManagementPageWithActions.vue?vue&type=template&id=6f072ffe&scoped=true&lang=pug"
import script from "./ManagementPageWithActions.vue?vue&type=script&lang=js"
export * from "./ManagementPageWithActions.vue?vue&type=script&lang=js"

import "./ManagementPageWithActions.vue?vue&type=style&index=0&id=6f072ffe&lang=scss"
import "./ManagementPageWithActions.vue?vue&type=style&index=1&id=6f072ffe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f072ffe"]])

export default __exports__